var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.9 0C111.8 0-.1 111.9-.1 250s111.9 250 250 250 250-111.9 250-250S388 0 249.9 0zm0 479.1C123.6 479.1 20.8 376.3 20.8 250S123.6 20.9 249.9 20.9 479 123.7 479 250 376.2 479.1 249.9 479.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 177.867 170.314)",
    cx: 177.9,
    cy: 170.3,
    r: 27.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300.1 207c-22.3 0-32.8 8.2-39.8 18.7v-10.5c0-3.4-2.8-6.2-6.2-6.2h-29.8c-3.4 0-6.2 2.8-6.2 6.2v121.6c0 3.4 2.8 6.2 6.2 6.2h29.8c3.4 0 6.2-2.8 6.2-6.2v-65.2c.8-8.8 4.6-28.3 23.6-28.3 24.5 0 22 28.5 22 37v56.5c0 3.4 2.8 6.2 6.2 6.2H343c3.4 0 6.2-2.8 6.2-6.2v-58.3c0-25.4.3-71.5-49.1-71.5zm-107.9 2h-28.7c-3.7 0-6.8 3-6.8 6.8v120.5c0 3.7 3 6.8 6.8 6.8h28.7c3.7 0 6.8-3 6.8-6.8V215.7c0-3.7-3-6.7-6.8-6.7z"
  })));
}
export default SvgIconLinkedin;